import React from 'react';

export const OrganizationKeyContext = React.createContext<string | null>(null);
